/**
 * readingStats
 * Word count + estimated reading time (~200 wpm, min 1 minute) for a piece of text.
 */

export function readingStats(text) {
  const words = (text || '').trim().split(/\s+/).filter(Boolean).length;
  const minutes = words === 0 ? 0 : Math.max(1, Math.round(words / 200));
  return { words, minutes };
}
